// extracted by mini-css-extract-plugin
module.exports = {"desktopMenu":"DesktopMenu_desktopMenu__Jw_zF"};